import React from "react";
import {Config} from '../Config';
import * as Utils from '../inc/Utils';
import {NavLink, useSearchParams} from "react-router-dom";
import frameDefault from "../img/thumb/frame-100x60.png";
import defaultImage from "../img/default.jpg";
import Pagination from "react-js-pagination";
import moment from "moment-timezone";

export default function LicenceProvider(prop) {
    let [searchParams] = useSearchParams();

    let [data, setData] = React.useState(null);
    let [listing, setListing] = React.useState(null);

    let [itemPerpage, setItemPerpage] = React.useState(12);
    let [countAllItem, setCountAllItem] = React.useState(0);
    let [activePage, setActivePage] = React.useState(1);
    let [totalPage, setTotalPage] = React.useState(0);

    let [certificationTypeList, setCertificationTypeList] = React.useState([]);
    let [certificationType, setCertificationType] = React.useState(null);
    let [statusList, setStatusList] = React.useState(null);

    let refKeyword = React.useRef();

    React.useEffect(() => {
        let title = (prop.lang === 'en' ? 'Cybersecurity Service Provider Information':'ข้อมูลผู้ประกอบการด้านความมั่นคงปลอดภัยไซเบอร์') + ' | NCSA';
        document.title = title;

        if(searchParams.get('certId')) {
            setCertificationType(searchParams.get('certId'));
        }
        else {
            setCertificationType(null);
        }
        if(searchParams.get('keyword')) {
            refKeyword.current.value = searchParams.get('keyword');
        }
        else {
            refKeyword.current.value = '';
        }

        (async function() {
            try {
                const resultStatus = await Utils.getFormStatus();
                setStatusList(resultStatus);

                const resView = await getView();
                setData(resView);

                const resCertificationType = await Utils.getCyberCertificationType();
                setCertificationTypeList(resCertificationType);

                const resListing = await getListing();
                setListing(resListing);
                if(resListing !== null) {
                    setCountAllItem(resListing.count);
                    setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
                }

                if(searchParams.get('typeId')) {
                    //await createSearch(searchParams.get('typeId'));
                }
            } catch (e) {
                //
            }
        })();
    }, [searchParams]);

    const onPageChange = async (pageNum) => {
        setActivePage(pageNum);
        const resListing = await getListing(pageNum);
        setListing(resListing);
        if(resListing !== null) {
            setCountAllItem(resListing.count);
            setTotalPage(resListing.count > 0 ? (resListing.count / itemPerpage) : 1);
        }
    };

    async function getView() {
        const response = await fetch(Config.apiUrl +'/researcherBanner/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: 1
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getListing(pageNum) {
        if(pageNum !== null) {
            activePage = pageNum;
        }

        let certificationType = null;
        if(searchParams.get('certId')) {
            certificationType = searchParams.get('certId');
        }

        const response = await fetch(Config.apiUrl +'/cyberForm/listApprove', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                keyword: refKeyword.current.value,
                certificationType: certificationType,
                itemPerpage: itemPerpage,
                startItem: activePage > 1 ? (activePage * itemPerpage)-itemPerpage : 0,
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onSearch = (e) => {
        let param = [];
        if(refKeyword.current.value) {
            param.push('keyword=' + refKeyword.current.value);
        }
        if(certificationType !== null) {
            param.push('certId=' + certificationType);
        }
        window.location = (prop.lang === 'en' ? '/en': '/') + 'licence-provider' + (param.length > 0 ? '?' + param.join('&') : '');
    };

    const onChangeCertificationType = (e) => {
        setCertificationType(e.target.value);
    };

    async function createSearch(serviceTypeId) {
        const response = await fetch(Config.apiUrl +'/cyberServiceTypeSearch/create', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                serviceTypeId: parseInt(serviceTypeId),
                createdBy: -1,
                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                updatedBy: -1,
                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section section-banner small">
                {
                    data?.image ? <img src={Config.fileUpload + 'researcher_banner/' + data?.image} alt="" /> : ''
                }
                <div className="container">
                    <h1 className="h2 textrow">
                        <span data-aos="fade-up">{prop.lang === 'en' ? 'Licensing of Cyber Security Service Provider':'ผู้ได้รับการรับรองคุณภาพผู้ประกอบการด้านความมั่นคงปลอดภัยไซเบอร์'}</span>
                    </h1>
                    <p data-aos="fade-in"><NavLink to="/">{prop.lang === 'en' ? 'Home':'หน้าแรก'}</NavLink> / {prop.lang === 'en' ? 'Licensing of Cyber Security Service Provider':'ผู้ได้รับการรับรองคุณภาพผู้ประกอบการด้านความมั่นคงปลอดภัยไซเบอร์'}</p>
                </div>
            </div>

            <div className="section">
                <div className="container">

                    <div className="p-4" style={{backgroundColor:'#dddddd'}}>
                        <div className="row g-3">
                            <div className="col-md-4">
                                <input type="text" className="form-control" placeholder={prop.lang === 'en' ? 'Enter keyword Ex. company name, person name':'ระบุ ชื่อบริษัท/คณะบุคคล'} maxLength={50} ref={refKeyword} />
                            </div>
                            {
                                certificationTypeList !== null && certificationTypeList.length > 0 ?
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <select className="form-select" onChange={onChangeCertificationType} defaultValue={certificationType}>
                                                <option value="">{prop.lang === 'en' ? 'All Certification Type' : 'ประเภทที่ได้รับการรับรองทั้งหมด'}</option>
                                                {
                                                    certificationTypeList.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en : row.title}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div> : ''
                            }
                            <div className="col-md-4">
                                <button className="btn w-100" type="button" onClick={onSearch}>{prop.lang === 'en' ? 'Search':'แสดงผลการค้นหา'}</button>
                            </div>
                        </div>
                    </div>

                    {
                        listing !== null && listing.count > 0 ?
                        <>
                            <div className="table-responsive mt-3">
                                <table className="table table-striped mb-0">
                                    <thead>
                                        <tr>
                                            <th>ลำดับ</th>
                                            <th>ชื่อบริษัท/คณะบุคคล</th>
                                            <th>บริการที่ได้รับการรับรอง</th>
                                            <th className="text-center">วันที่ยื่น</th>
                                            <th className="text-center">วันที่อนุมัติ</th>
                                            <th className="text-center">วันที่หมดอายุ</th>
                                            <th className="text-center">สถานะ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        listing.rows.map((row, index) => {
                                            let no = index+1;
                                            if(activePage > 1) no = ((activePage * itemPerpage)-itemPerpage + no);
                                            return (
                                                <tr key={index}>
                                                    <td>{no}</td>
                                                    <td>{row.fullname}</td>
                                                    <td>
                                                        {row?.certificate?.code && row?.certificate?.fileCertificate ? <NavLink to={Config.fileUpload.replace('/FileUpload', '') + 'certificate/' + row?.certificate?.fileCertificate} className="me-1 download-link" target="blank">{row?.certificate?.code}</NavLink> : ''}
                                                        {row?.certificateType ? (prop.lang === 'en' ? row?.certificateType?.title_en : row?.certificateType?.title) : ''}
                                                        {row?.certificateLevel ? (prop.lang === 'en' ? ' (' + row?.certificateLevel?.title_en + ')' : ' (' + row?.certificateLevel?.title + ')') : ''}
                                                    </td>
                                                    <td className="text-center">{Utils.dateText(row.createdAt, '-')}</td>
                                                    <td className="text-center">{row?.certificate?.startDate ? Utils.dateText(row.certificate.startDate, '-') : '-'}</td>
                                                    <td className="text-center">{row?.certificate?.expireDate ? Utils.dateText(row.certificate.expireDate, '-') : '-'}</td>
                                                    <td className="text-center">
                                                        <span className={"badge bg-success"}>APPROVED</span>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                    </tbody>
                                </table>
                            </div>

                            <div className={totalPage > 1 ? '':'d-none'}>
                                <Pagination
                                    itemClassPrev="arrow prev"
                                    itemClassNext="arrow next"
                                    activeClass="active"
                                    itemClass=""
                                    linkClass=""
                                    innerClass="pagination"
                                    activePage={activePage}
                                    itemsCountPerPage={itemPerpage}
                                    totalItemsCount={countAllItem}
                                    pageRangeDisplayed={5}
                                    onChange={(pageNum) => onPageChange(pageNum)}
                                />
                            </div>

                        </> : <p className="text-center py-4">{prop.lang === 'en' ? 'Not found':'ไม่พบข้อมูล'}</p>

                    }
                </div>
            </div>
        </>
    );
} 